export default "__VITE_ASSET__ae0fded7__"